<template>
  <div class="content c895">
    <h2>Pralni stroj 1</h2>
  </div>
  <div class="content c590">
    <div class="popup popDev2" style="display:none;">
      <div class="inner">
        <h3>Ali ste prepričani, da želite izbrisati napravo?</h3>
        <div class="msg">
          <h3>Pralni stroj</h3>
        </div>
        <div class="con">
          <p>Izbrišite napravo, če ste se zmotili pri njenih podatkih oziroma ste izbrali napačno napravo. Če bi želeli, jo lahko kasneje brez težav ponovno dodate.</p>
        </div>
        <div class="btns">
          <a
            href="javascript:void(0)"
            class="btn"
            title="Več"
            onclick="popupDelete(&quot;popDev2&quot;)"
          >NE, PREKLIČI</a>
          <a
            id="ctl00_ContentPlaceHolder1_lnkBtnDeleteDevice"
            class="btn"
            href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$lnkBtnDeleteDevice','')"
          >DA, IZBRIŠI</a>
        </div>
      </div>
    </div>
    <div class="appliance">
      <table>
        <tbody>
          <tr>
            <td class="first">Pralni stroj</td>
            <td>A+++ (-20%, po 2015)</td>
            <td class="last">
              <div class="tools">
                <a
                  href="javascript:void(0)"
                  title="Zbriši"
                  class="close"
                  onclick="popupDelete(&quot;popDev2&quot;)"
                >Zbriši</a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="appliance data">
      <div class="icon">
        <span class="PS">Pralni stroj</span>
      </div>
      <div class="first">
        <h5>TRENUTNA PORABA</h5>
        <span id="ctl00_ContentPlaceHolder1_lblConsumption">
          <span class="et">
            16,76 kWh / leto
            <div class="tooltip-bottom">
              Enotna tarifa (ET) je tarifa, ki jo beleži enotarifni števec vsak dan od 0.00 do 24.00 ure. Cena električne energije je ves čas enaka. V primeru, da imate enotarifno merjenje in želite dvotarifnega, pokličite v vaše elektrodistribucijsko podjetje za podrobnejše informacije.
              <br />
              <a
                href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov/predstavitev#tarife"
                target="_blank"
                title="Več"
              >Več o tem &gt;</a>
            </div>
          </span>
        </span>
        <em>
          <span id="ctl00_ContentPlaceHolder1_lblTotalPrice">1,26 € / leto</span>
        </em>
      </div>

      <div class="no-data">
        <h5>VAŠI PRIHRANKI</h5>
        <h5>VAŠA NOVA PORABA</h5>
        <div class="message">
          <p>Za izračun nove porabe in prihrankov na izbrani napravi izvedi vsaj en ukrep.</p>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="toggle-btn" style="display:none;">
        <a href="javascript:void(0)" class="active">Prihranki zaradi izvedenih ukrepov</a>
      </div>
      <ul class="actionsExistingUl"></ul>

      <h3>Zmanjšajte porabo naprave Pralni stroj</h3>
      <p>Zmanjšajte porabo tako, da izvedete vsaj enega, še bolje pa več, spodaj navedenih ukrepov. Izberite le tiste, ki so v vaših razmerah pomembni.</p>
      <ul>
        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_divAction">
          <a
            class="actionBtnMore active"
            style="cursor:pointer;"
          >Zamenjamo naš stari pralni stroj z novim, ki je energetsko bolj učinkovit</a>

          <div style class="actionPnlMore">
            <div id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_Panel2">
              <div class="form">
                <h3>Izberite lastnosti novega Pralnega stroja:</h3>
                <fieldset>
                  <div class="f-item select">
                    <label>
                      Energijski razred:
                      <span>(oz. leto izdelave naprave)</span>
                    </label>
                    <span
                      id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_RequiredFieldValidator1"
                      style="color:Red;float:none;font-size:1em;visibility:hidden;"
                    >*</span>
                    <select
                      name="ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$ddlClassWashing"
                      id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_ddlClassWashing"
                    >
                      <option value="0">Izberite</option>
                      <option value="188">A+++ (-20%, po 2015)</option>
                      <option value="108">A+++ (po 2005)</option>
                      <option value="107">A++ (po 2005)</option>
                      <option value="187">A+++ (po 2015)</option>
                      <option value="186">A++ (po 2015)</option>
                      <option value="70">A+ (po 2005)</option>
                      <option value="71">A (po 2005)</option>
                      <option value="72">B (2001-2004)</option>
                      <option value="73">C (1999-2000)</option>
                      <option value="74">D (1997-1998)</option>
                      <option value="75">E (1995-1996)</option>
                      <option value="76">F (1993 - 1994)</option>
                    </select>
                    <!-- tooltip + div added-->
                    <div class="help">
                      <a href="#" class="help" title="Help">Help</a>
                      <div
                        class="tooltip"
                      >Pralni stroji se razlikujejo tako po priključni moči, kot po porabi električne energije. Varčni porabijo tudi za skoraj polovico manj električne energije, z energijo pa varčujete tudi, če varčujete z vodo.</div>
                    </div>
                    <!-- //end -->
                  </div>
                </fieldset>
              </div>
            </div>

            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_lnkBtnAdd"
                  class="btn"
                  href="javascript:WebForm_DoPostBackWithOptions(new WebForm_PostBackOptions(&quot;ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$lnkBtnAdd&quot;, &quot;&quot;, true, &quot;ChangeDevice&quot;, &quot;&quot;, false, true))"
                >Izvedi ukrep</a>
              </div>
              <p>Na porabo pralnega stroja najbolj vplivata njegova energijska učinkovitost in program, ki ga uporabljamo za pranje. Če je pralni stroj star, nam povzroča težave ali nima dovolj nastavljivih možnosti pri programih pranja, je priporočljivo, da kupimo novega, ki ga je mogoče ustrezno programirati in ima čim boljši energijski razred (A++ ali A+++). S tem bomo povečali prihranke na tej napravi.</p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl01_divAction">
          <a class="actionBtnMore" style="cursor:pointer;">Za pranje perila izberemo varčni program</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl01_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl01$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>Kadar imamo manj umazano perilo (recimo poleti, ko je le preznojeno), izberemo varčen program z nižjo temperaturo pranja. Na ta način lahko prihranimo tudi do 40 % električne energije.</p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl02_divAction">
          <a class="actionBtnMore" style="cursor:pointer;">Ne uporabljamo funkcije predpranje</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl02_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl02$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>Na modernejših pralnih strojih je treba funkcijo predpranja posebej vklopiti, a tudi na starejših jo lahko izklopimo. Tako dodatno privarčujemo 10 % električne energije.</p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl03_divAction">
          <a
            class="actionBtnMore"
            style="cursor:pointer;"
          >Perimo le takrat ko je perila za poln boben</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl03_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl03$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>Pralni stroj uporabimo šele takrat, ko je boben poln. V primeru da peremo pogosteje, torej večkrat, čeprav z manj polnim bobnom, bomo porabili za okoli 10 % več električne energije.</p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl04_divAction">
          <a
            class="actionBtnMore"
            style="cursor:pointer;"
          >Če imamo na voljo solarni vir ogrevanja vode, priklopimo nanj pralni stroj</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl04_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl04$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>V primeru, ko imamo pripravo tople vode urejeno s solarnim sistemom s temperaturo do 60 °C, lahko priključimo pralni stroj na dovod tople vode. Na ta način prihranimo okoli 25 % električne energije.</p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl05_divAction">
          <a class="actionBtnMore" style="cursor:pointer;">Perimo le v času nižje tarife (MT)</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl05_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl05$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>
                Če peremo perilo le
                <a
                  href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov#tarife"
                  target="_blank"
                >v času nižje tarife</a>, lahko v primerjavi s pranjem le v času višje tarife (VT) prihranimo na stroških porabljene energije, ki jo porabi samo pralni stroj, okoli 30 %.
              </p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="advice">
      <h4>Imejte vedno v mislih, da lahko prihranite!</h4>
      <p>Zgornji ukrepi so merljivi in ob njihovem izvajanju točno veste, koliko energije lahko prihranite. Toda za vse električne naprave v gospodinjstvu, tako večje kot majhne, smo zbrali še kopico nasvetov, ki vam lahko pomagajo dodatno prihraniti, čeprav prihranka zaradi različnosti naprav in situacij za te nasvete ni mogoče količinsko opredeliti.</p>
      <a
        href="http://www.uresnicujmo.si/nasveti/hladilnik"
        target="_blank"
        alt="več"
        class="more"
      >PREBERITE NASVETE</a>
    </div>
  </div>
  <div class="content r-c">
    <div class="c282">
      <h3>PORABA NAPRAVE PRALNI STROJ 1</h3>
      <div class="select">
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageType"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageType\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageType"
          class="s156"
        >
          <option selected="selected" value="1">Kumulativna poraba (€)</option>
          <option value="2">Kumulativna poraba (kWh)</option>
        </select>
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageTSpan"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageTSpan\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageTSpan"
        >
          <option selected="selected" value="1">za 1 leto</option>
          <option value="5">za 5 let</option>
          <option value="10">za 10 let</option>
          <option value="15">za 15 let</option>
        </select>
      </div>

      <div class="graph">
        <div class="chart">
          <div
            id="ctl00_ContentPlaceHolder1_divCurrentUsage"
            class="col without"
            style="height:100%;"
          >
            <span id="ctl00_ContentPlaceHolder1_lblCurrentUsage">1,26 €</span>
          </div>
        </div>
        <div class="legend">
          <div class="col">
            <strong>Poraba brez</strong> izvedenih ukrepov
          </div>
          <div class="col">
            <strong>Poraba z</strong> izvedenimi ukrepi
          </div>
        </div>
      </div>
    </div>
    <div class="c282">
      <h3>PORABA NAPRAVE PRALNI STROJ 1</h3>
      <div class="select">
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageType2"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageType2\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageType2"
          class="s156"
        >
          <option selected="selected" value="1">Kumulativna poraba (€)</option>
          <option value="2">Kumulativna poraba (kWh)</option>
        </select>
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageTSpan2"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageTSpan2\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageTSpan2"
        >
          <option value="1">za 1 leto</option>
          <option selected="selected" value="5">za 5 let</option>
          <option value="10">za 10 let</option>
          <option value="15">za 15 let</option>
        </select>
      </div>
      <div class="graph image">
        <div class="chart">
          <img
            id="ctl00_ContentPlaceHolder1_Chart1"
            src="/Images/Charts/Chart000001.png?1c8e9136-bf3b-4262-98a0-3f6b8e65aed4"
            alt
            usemap="#ctl00_ContentPlaceHolder1_Chart1ImageMap"
            style="height:168px;width:263px;border-width:0px;padding:0;"
          />
          <map
            name="ctl00_ContentPlaceHolder1_Chart1ImageMap"
            id="ctl00_ContentPlaceHolder1_Chart1ImageMap"
          >
            <area
              shape="poly"
              coords="197, 144, 197, 58, 197, 58, 257, 36, 257, 36, 257, 144, 197, 144"
              title="13.11.2025; 6,3239793344"
              alt
            />
            <area
              shape="poly"
              coords="137, 144, 137, 79, 137, 79, 197, 58, 197, 58, 197, 144, 137, 144"
              title="13.11.2024; 5,05918346752"
              alt
            />
            <area
              shape="poly"
              coords="77, 144, 77, 101, 77, 101, 137, 79, 137, 79, 137, 144, 77, 144"
              title="13.11.2023; 3,79438760064"
              alt
            />
            <area
              shape="poly"
              coords="17, 144, 17, 122, 17, 122, 77, 101, 77, 101, 77, 144, 17, 144"
              title="13.11.2022; 2,52959173376"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 36, 257, 36, 17, 122, 17, 122, 17, 144, 257, 144"
              title="13.11.2021; 1,26479586688"
              alt
            />
            <area
              shape="poly"
              coords="197, 144, 197, 58, 197, 58, 257, 36, 257, 36, 257, 144, 197, 144"
              title="13.11.2025; 6,3239793344"
              alt
            />
            <area
              shape="poly"
              coords="137, 144, 137, 79, 137, 79, 197, 58, 197, 58, 197, 144, 137, 144"
              title="13.11.2024; 5,05918346752"
              alt
            />
            <area
              shape="poly"
              coords="77, 144, 77, 101, 77, 101, 137, 79, 137, 79, 137, 144, 77, 144"
              title="13.11.2023; 3,79438760064"
              alt
            />
            <area
              shape="poly"
              coords="17, 144, 17, 122, 17, 122, 77, 101, 77, 101, 77, 144, 17, 144"
              title="13.11.2022; 2,52959173376"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 36, 257, 36, 17, 122, 17, 122, 17, 144, 257, 144"
              title="13.11.2021; 1,26479586688"
              alt
            />
            <area
              shape="poly"
              coords="197, 144, 197, 58, 197, 58, 257, 36, 257, 36, 257, 144, 197, 144"
              title="13.11.2025; 6,3239793344"
              alt
            />
            <area
              shape="poly"
              coords="137, 144, 137, 79, 137, 79, 197, 58, 197, 58, 197, 144, 137, 144"
              title="13.11.2024; 5,05918346752"
              alt
            />
            <area
              shape="poly"
              coords="77, 144, 77, 101, 77, 101, 137, 79, 137, 79, 137, 144, 77, 144"
              title="13.11.2023; 3,79438760064"
              alt
            />
            <area
              shape="poly"
              coords="17, 144, 17, 122, 17, 122, 77, 101, 77, 101, 77, 144, 17, 144"
              title="13.11.2022; 2,52959173376"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 36, 257, 36, 17, 122, 17, 122, 17, 144, 257, 144"
              title="13.11.2021; 1,26479586688"
              alt
            />
            <area
              shape="poly"
              coords="197, 144, 197, 58, 197, 58, 257, 36, 257, 36, 257, 144, 197, 144"
              title="13.11.2025; 6,3239793344"
              alt
            />
            <area
              shape="poly"
              coords="137, 144, 137, 79, 137, 79, 197, 58, 197, 58, 197, 144, 137, 144"
              title="13.11.2024; 5,05918346752"
              alt
            />
            <area
              shape="poly"
              coords="77, 144, 77, 101, 77, 101, 137, 79, 137, 79, 137, 144, 77, 144"
              title="13.11.2023; 3,79438760064"
              alt
            />
            <area
              shape="poly"
              coords="17, 144, 17, 122, 17, 122, 77, 101, 77, 101, 77, 144, 17, 144"
              title="13.11.2022; 2,52959173376"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 36, 257, 36, 17, 122, 17, 122, 17, 144, 257, 144"
              title="13.11.2021; 1,26479586688"
              alt
            />
            <area
              shape="poly"
              coords="197, 144, 197, 58, 197, 58, 257, 36, 257, 36, 257, 144, 197, 144"
              title="13.11.2025; 6,3239793344"
              alt
            />
            <area
              shape="poly"
              coords="137, 144, 137, 79, 137, 79, 197, 58, 197, 58, 197, 144, 137, 144"
              title="13.11.2024; 5,05918346752"
              alt
            />
            <area
              shape="poly"
              coords="77, 144, 77, 101, 77, 101, 137, 79, 137, 79, 137, 144, 77, 144"
              title="13.11.2023; 3,79438760064"
              alt
            />
            <area
              shape="poly"
              coords="17, 144, 17, 122, 17, 122, 77, 101, 77, 101, 77, 144, 17, 144"
              title="13.11.2022; 2,52959173376"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 36, 257, 36, 17, 122, 17, 122, 17, 144, 257, 144"
              title="13.11.2021; 1,26479586688"
              alt
            />
            <area
              shape="poly"
              coords="197, 144, 197, 58, 197, 58, 257, 36, 257, 36, 257, 144, 197, 144"
              title="13.11.2025; 6,3239793344"
              alt
            />
            <area
              shape="poly"
              coords="137, 144, 137, 79, 137, 79, 197, 58, 197, 58, 197, 144, 137, 144"
              title="13.11.2024; 5,05918346752"
              alt
            />
            <area
              shape="poly"
              coords="77, 144, 77, 101, 77, 101, 137, 79, 137, 79, 137, 144, 77, 144"
              title="13.11.2023; 3,79438760064"
              alt
            />
            <area
              shape="poly"
              coords="17, 144, 17, 122, 17, 122, 77, 101, 77, 101, 77, 144, 17, 144"
              title="13.11.2022; 2,52959173376"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 36, 257, 36, 17, 122, 17, 122, 17, 144, 257, 144"
              title="13.11.2021; 1,26479586688"
              alt
            />
            <area
              shape="poly"
              coords="197, 144, 197, 58, 197, 58, 257, 36, 257, 36, 257, 144, 197, 144"
              title="13.11.2025; 6,3239793344"
              alt
            />
            <area
              shape="poly"
              coords="137, 144, 137, 79, 137, 79, 197, 58, 197, 58, 197, 144, 137, 144"
              title="13.11.2024; 5,05918346752"
              alt
            />
            <area
              shape="poly"
              coords="77, 144, 77, 101, 77, 101, 137, 79, 137, 79, 137, 144, 77, 144"
              title="13.11.2023; 3,79438760064"
              alt
            />
            <area
              shape="poly"
              coords="17, 144, 17, 122, 17, 122, 77, 101, 77, 101, 77, 144, 17, 144"
              title="13.11.2022; 2,52959173376"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 36, 257, 36, 17, 122, 17, 122, 17, 144, 257, 144"
              title="13.11.2021; 1,26479586688"
              alt
            />
            <area
              shape="poly"
              coords="197, 144, 197, 58, 197, 58, 257, 36, 257, 36, 257, 144, 197, 144"
              title="13.11.2025; 6,3239793344"
              alt
            />
            <area
              shape="poly"
              coords="137, 144, 137, 79, 137, 79, 197, 58, 197, 58, 197, 144, 137, 144"
              title="13.11.2024; 5,05918346752"
              alt
            />
            <area
              shape="poly"
              coords="77, 144, 77, 101, 77, 101, 137, 79, 137, 79, 137, 144, 77, 144"
              title="13.11.2023; 3,79438760064"
              alt
            />
            <area
              shape="poly"
              coords="17, 144, 17, 122, 17, 122, 77, 101, 77, 101, 77, 144, 17, 144"
              title="13.11.2022; 2,52959173376"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 36, 257, 36, 17, 122, 17, 122, 17, 144, 257, 144"
              title="13.11.2021; 1,26479586688"
              alt
            />
            <area
              shape="poly"
              coords="197, 144, 197, 58, 197, 58, 257, 36, 257, 36, 257, 144, 197, 144"
              title="13.11.2025; 6,3239793344"
              alt
            />
            <area
              shape="poly"
              coords="137, 144, 137, 79, 137, 79, 197, 58, 197, 58, 197, 144, 137, 144"
              title="13.11.2024; 5,05918346752"
              alt
            />
            <area
              shape="poly"
              coords="77, 144, 77, 101, 77, 101, 137, 79, 137, 79, 137, 144, 77, 144"
              title="13.11.2023; 3,79438760064"
              alt
            />
            <area
              shape="poly"
              coords="17, 144, 17, 122, 17, 122, 77, 101, 77, 101, 77, 144, 17, 144"
              title="13.11.2022; 2,52959173376"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 36, 257, 36, 17, 122, 17, 122, 17, 144, 257, 144"
              title="13.11.2021; 1,26479586688"
              alt
            />
            <area
              shape="poly"
              coords="197, 144, 197, 58, 197, 58, 257, 36, 257, 36, 257, 144, 197, 144"
              title="13.11.2025; 6,3239793344"
              alt
            />
            <area
              shape="poly"
              coords="137, 144, 137, 79, 137, 79, 197, 58, 197, 58, 197, 144, 137, 144"
              title="13.11.2024; 5,05918346752"
              alt
            />
            <area
              shape="poly"
              coords="77, 144, 77, 101, 77, 101, 137, 79, 137, 79, 137, 144, 77, 144"
              title="13.11.2023; 3,79438760064"
              alt
            />
            <area
              shape="poly"
              coords="17, 144, 17, 122, 17, 122, 77, 101, 77, 101, 77, 144, 17, 144"
              title="13.11.2022; 2,52959173376"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 36, 257, 36, 17, 122, 17, 122, 17, 144, 257, 144"
              title="13.11.2021; 1,26479586688"
              alt
            />
            <area
              shape="poly"
              coords="197, 144, 197, 58, 197, 58, 257, 36, 257, 36, 257, 144, 197, 144"
              title="13.11.2025; 6,3239793344"
              alt
            />
            <area
              shape="poly"
              coords="137, 144, 137, 79, 137, 79, 197, 58, 197, 58, 197, 144, 137, 144"
              title="13.11.2024; 5,05918346752"
              alt
            />
            <area
              shape="poly"
              coords="77, 144, 77, 101, 77, 101, 137, 79, 137, 79, 137, 144, 77, 144"
              title="13.11.2023; 3,79438760064"
              alt
            />
            <area
              shape="poly"
              coords="17, 144, 17, 122, 17, 122, 77, 101, 77, 101, 77, 144, 17, 144"
              title="13.11.2022; 2,52959173376"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 36, 257, 36, 17, 122, 17, 122, 17, 144, 257, 144"
              title="13.11.2021; 1,26479586688"
              alt
            />
            <area
              shape="poly"
              coords="197, 144, 197, 58, 197, 58, 257, 36, 257, 36, 257, 144, 197, 144"
              title="13.11.2025; 6,3239793344"
              alt
            />
            <area
              shape="poly"
              coords="137, 144, 137, 79, 137, 79, 197, 58, 197, 58, 197, 144, 137, 144"
              title="13.11.2024; 5,05918346752"
              alt
            />
            <area
              shape="poly"
              coords="77, 144, 77, 101, 77, 101, 137, 79, 137, 79, 137, 144, 77, 144"
              title="13.11.2023; 3,79438760064"
              alt
            />
            <area
              shape="poly"
              coords="17, 144, 17, 122, 17, 122, 77, 101, 77, 101, 77, 144, 17, 144"
              title="13.11.2022; 2,52959173376"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 36, 257, 36, 17, 122, 17, 122, 17, 144, 257, 144"
              title="13.11.2021; 1,26479586688"
              alt
            />
            <area
              shape="poly"
              coords="197, 144, 197, 58, 197, 58, 257, 36, 257, 36, 257, 144, 197, 144"
              title="13.11.2025; 6,3239793344"
              alt
            />
            <area
              shape="poly"
              coords="137, 144, 137, 79, 137, 79, 197, 58, 197, 58, 197, 144, 137, 144"
              title="13.11.2024; 5,05918346752"
              alt
            />
            <area
              shape="poly"
              coords="77, 144, 77, 101, 77, 101, 137, 79, 137, 79, 137, 144, 77, 144"
              title="13.11.2023; 3,79438760064"
              alt
            />
            <area
              shape="poly"
              coords="17, 144, 17, 122, 17, 122, 77, 101, 77, 101, 77, 144, 17, 144"
              title="13.11.2022; 2,52959173376"
              alt
            />
          </map>
        </div>
        <div class="legend">
          <ul>
            <li class="without">Poraba brez izvedenih ukrepov</li>
            <li class="with">Poraba z izvedenimi ukrepi</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.data .icon .PS {
  background-position: -438px -477px;
}
</style>